<div fxLayout="row wrap" class="margin--1">
  <!-- Use ng-template to ensure that the generated components end up in the right place -->
  <ng-container *ngIf="cards as cards">
  </ng-container>

  <ng-template #container>
  </ng-template>
</div>
